<template>
    <b-overlay :show="pageBusy" variant="transparent">
        <b-card>
            <div class="row pt-0">
                <div class="col-12 pb-1">
                    <span class="font-weight-bolder">Filters</span>
                </div>
                <div class="col-lg-4 col-12 col-md-6">
                    <label>Date Range</label>
                    <flat-pickr
                        v-model="range"
                        class="form-control"
                        :config="{ mode: 'range'}"
                        />
                </div>
                <!-- <div class="col-lg-4 col-12 col-md-6">
                    <label>State</label>
                    <v-select  v-model="status"  :options="statusOptions"></v-select>
                </div> -->
                <!-- <div class="col-lg-4 col-12 col-md-6">
                    <label>Name</label>
                    <input v-model="searchName" type="text" class="form-control" placeholder="">
                </div> -->
                <div class="col-lg-4 col-12 col-md-6 pt-2 pt-lg-2">
                    <b-button variant="primary" @click="filterPricings()" disabled> <feather-icon icon="SearchIcon" /> Search</b-button>
                </div>
            </div>
        </b-card>
        <b-card>
            <div class="pb-1">
              <b-button @click="triggerAddPricing()" variant="primary">Add Pricing</b-button>
            </div>
            <b-modal id="add-pricing-modal" centered ok-title="Save" @ok="submittedPricing" :title="pricing.id ? 'Update Pricing': 'Create Pricing'" no-close-on-backdrop no-close-on-esc>
                <div class="row">
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">Name</label> <small class="text-danger">*</small>
                          <b-form-input v-model="pricing.name" autofocus />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">French name</label>
                          <b-form-input v-model="pricing.nameFr" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">Duration (days)</label>
                          <b-form-input v-model="pricing.duration" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">Amount (XAF)</label>
                          <b-form-input v-model="pricing.amount" />
                        </div>
                    </div>

                </div>
            </b-modal>
            <b-overlay :show="itemBusy">
                <b-table
                    class="rounded border"
                    :items="items"
                    :fields="fields"
                    :per-page="10"
                    :current-page="1"
                    responsive
                >

                    <template #head()="scope">
                        <div class="text-nowrap text-primary">
                        {{ scope.label }}
                        </div>
                    </template>
                    <template #cell(name)="data">
                        <div class="text-nowrap pt-1" v-if="data.item.id">
                            {{data.value}} ({{data.item.nameFr}})
                        </div>
                    </template>
                    <template #cell(amount)="data">
                        <div class="text-nowrap pt-1" v-if="data.item.id">
                            <span class="text-dark">{{currency(data.item.amount)}}</span> <small>{{data.item.currencyCode}}</small>
                        </div>
                    </template>
                    <template #cell(netAmount)="data">
                        <div class="text-nowrap pt-1 small" v-if="data.item.id">
                            <span style="font-size: 20px;" class="font-weight-bolder text-dark">{{currency(data.item.amount * data.item.duration)}}</span> <small>{{data.item.currencyCode}}</small>
                        </div>
                    </template>
                    <template #cell(status)="data">
                        <span class="text-nowrap" v-if="data.item.id">
                            <b-badge v-if="data.item.isActive" variant="success">
                                Active
                            </b-badge>
                            <b-badge variant="danger" v-else>
                                Inactive
                            </b-badge>
                        </span>
                    </template>
                    <template #cell()="data">
                        <div class="text-nowrap pt-1">
                            {{data.value}}
                        </div>
                    </template>
                    <template #cell(createdAt)="data">
                        <div class="text-nowrap pt-1" v-if="data.item.id">
                            {{ date(data.value) }}
                        </div>
                    </template>
                    <template #cell(updatedAt)="data">
                        <div class="text-nowrap pt-1" v-if="data.item.id">
                            {{ date(data.value) }}
                        </div>
                        <div v-else class="p-1">

                        </div>
                    </template>
                    <template #cell(actions)="data">
                      <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                        v-if="data.item.id"
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </template>
                        <b-dropdown-item @click="triggerEditPricing(data.item)">
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="triggerToggleVisibility(data.item)">
                          <feather-icon icon="EyeIcon"  />
                          <span class="align-middle ml-50">Toggle visibility</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="deletePricing(data.item)">
                          <feather-icon icon="TrashIcon"  />
                          <span class="align-middle ml-50">Delete</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
    </b-overlay>


</template>

<script>

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Utils from '@/utils/index';
import API from './api'

const toast = useToast()
export default {
    name: 'Pricings',
    components: {
        flatPickr,
        vSelect,
    },
    data() {
        return {
            currency: Utils.formatCurrency,
            date: Utils.formatDate,
            pricing: {
                name: '',
                nameFr: '',
                duration: 1,
                amount: 250,
            },
            pricingType: 1,
            pricingTypes:[
                {label: 'Paid', value: true },
                {label: 'Free', value: false }
            ],
            currentPage: 1,
            totalRows: 10,
            range: '',
            searchDate: '',
            dateRange: '',
            searchName: '',
            status: 'All',
            statusOptions: [
                {'label':'Pending',"value": 1},
                {'label':'Processed',"value": 2},
                {'label':'All' },

            ],
            checked: '',
            images: [],
            items: [],
            fields: [
                { key: 'actions', label: 'Actions' },
                { key: 'amount', label: 'Amount' },
                { key: 'name', label: 'Name' },
                { key: 'duration', label: 'Duration (Days)' },
                { key: 'netAmount', label: 'Amount * duration' },
                { key: 'status', label: 'Status' },
                { key: 'pricingId', label: 'Pricing ID' },
                // { key: 'createdAt', label: 'Created At' },
                { key: 'updatedAt', label: 'Updated At' },
            ],
            searchParams: {},
            itemBusy: false,
            pageBusy: false,
        }
    },
    watch: {
        range(newRange, oldRange) {
            newRange = newRange.split(' to ');
            if(newRange.length === 2) {
                this.searchDate = {
                    from: newRange[0],
                    to: newRange[1]
                }
            }else if(newRange[0].length == 10) {
                 this.searchDate = {
                    from: newRange[0],
                    to: newRange[0]
                }
            }else {
                this.searchDate = '';
            }
        },
    },
    created() {
        this.items = Utils.completeTable();
        this.getPricings();
    },
    methods: {
      triggerAddPricing(){
        this.resetPricing();
        this.$bvModal.show('add-pricing-modal');
      },
      resetPricing(){
        this.pricing = {
            name: '',
            frName: '',
            desc: '',
            frDesc: '',
        }
      },
      triggerEditPricing(pricing){
        this.pricing = {...pricing};
        this.$bvModal.show('add-pricing-modal');
      },
      submittedPricing(e){
        e.preventDefault();
        if(!this.pricing.name || !this.pricing.nameFr){
          this.showToast('Please enter name and french name');
          return 0;
        }
        if(!this.pricing.amount){
            this.showToast('Please enter amount (XAF)');
            return 0;
        }
        if(!this.pricing.duration){
            this.showToast('Please enter duration (Days)');
            return 0;
        }
        const api = this.pricing.pricingId? 'updatePricing': 'addPricing';
        API[api]({...this.pricing}).then(res => {
          if(res.success){
            if(this.pricing.pricingId){
              this.items = this.items.map(item=>{
                if(item.pricingId == this.pricing.pricingId){
                  item = res.data;
                }
                return item;
              })
            }else{
                this.items.unshift(res.data);
                // this.getPricings();
            }
            this.resetPricing();
            this.$bvModal.hide('add-pricing-modal');
          }
        }).catch(err=>{
          console.log(err);
        })
      },
        loadNewPage(e,page) {
            e.preventDefault();
            this.getPricings(page);
        },
        getPricings(page = 1) {
            // this.pageBusy = true;
            API.getPricings( 'pageNum=' + page  ).then(res => {
                this.pageBusy = false;
                if (res.success && res.data) {
                    this.currentPage = res.data.currentPage || 1;
                    this.items = Utils.completeTable(res.data);
                    this.totalRows = res.data.total || 10;
                }
            }).catch(() => {
                this.pageBusy = false;
                this.showToast();
            })
        },
         filterPricings() {
            if(!this.searchDate && !this.searchName && !this.status) {
                this.searchParams = {};
            }else{
                this.searchParams = {};
                if(this.searchName) {
                    this.searchParams.name = this.searchName;
                }
                if(this.status && this.status.value) {
                    this.searchParams.status = this.status.value;
                }
                if(this.searchDate && this.searchDate.from) {
                    this.searchParams.startDate = this.searchDate.from + ' 00:00:00';
                    if(!this.searchDate.to) {
                        this.this.searchDate.to = this.searchDate.from
                    }
                    this.searchParams.endDate = this.searchDate.to + ' 23:59:59';
                }
            }
            this.getPricings(1);
            this.currentPage = 1;
        },
        showToast(message, icon, variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message || 'Error fetching pricings',
                    icon: icon || 'InfoIcon',
                    variant: variant || 'danger',
                },
            })
        },
        showModal(description) {
            this.$bvModal.msgBoxOk(description, {
            title: 'Pricing',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            headerClass: 'p-2 border-bottom-0',
            bodyClass: 'text-break',
            footerClass: 'p-2 border-top-0',
            centered: true
            })
            .then(value => {
                // value returns true if ok was clicked
            })
            .catch(err => {
                // An error occurred
            })
        },
        triggerToggleVisibility(item) {
            this.$bvModal.msgBoxConfirm("Are you sure you want to toggle visibility", {
            title: 'Toggle',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            bodyClass: 'text-break',
            footerClass: 'p-2 border-top-0',
            cancelTitle: 'Cancel',
            centered: true
            })
            .then(value => {
                if(value){
                    this.toggleVisibility(item);
                }
            })
            .catch(err => {
                // An error occurred
            })
        },
        deletePricing(item) {
            this.$bvModal.msgBoxConfirm(`Are you sure you want to delete this pricing? "${item.name}"`, {
            title: 'Delete Pricing',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            bodyClass: 'text-break',
            footerClass: 'p-2 border-top-0',
            cancelTitle: 'Cancel',
            centered: true
            })
            .then(value => {
                if(value){
                    API.deletePricing(item.pricingId).then(res => {
                        this.pageBusy = false;
                        if(res.success) {
                            this.items = this.items.filter(e=> e.pricingId != item.pricingId);
                            this.showToast('Pricing deleted successfully', 'CheckIcon', 'success');
                        }
                    }).catch(() => {
                        this.pageBusy = false;
                        this.showToast('Failed to delete pricing');
                    })
                }
            })
            .catch(err => {
                // An error occurred
            })
        },
        toggleVisibility(item) {
            const params = {
                isActive: !item.isActive,
                pricingId: item.pricingId
            }
          API.updatePricing(params).then(res => {
            this.pageBusy = false;
            if(res.success) {
              this.items = this.items.map(e=>{
                if(e.pricingId == res.data.pricingId){
                    e = res.data;
                }
                return e
              })
                // this.getPricings(this.currentPage);
                this.showToast('Visibility toggled successfully', 'CheckIcon', 'success');
            }
          }).catch(() => {
              this.pageBusy = false;
              this.showToast('Failed to toggle visibility');
          })
        }
    }
}
</script>

<style lang="scss" scope>

    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-flatpicker.scss';

    .pricing-content{

        max-width: 100px !important;
    }
    .pricing-content:hover{
        transform: scale(1.2);
    }
</style>